import { render, staticRenderFns } from "./medic_sys_cat_details.vue?vue&type=template&id=d025ec2c"
import script from "./medic_sys_cat_details.vue?vue&type=script&lang=js"
export * from "./medic_sys_cat_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports